import React from 'react';

import { CssBaseline, ThemeProvider } from '@material-ui/core';

import AuthContextProvider from '../../auth';
import { LoadingProvider } from '../../Spinner';
import { MainTheme } from '../../Theme/theme';

const AppProviders = ({ children, useAuth = true, themeDomain = 'touzen' }) => {
  const theme = MainTheme(themeDomain);
  const content = useAuth ? (
    <AuthContextProvider>{children}</AuthContextProvider>
  ) : (
    children
  );

  return (
    <LoadingProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {content}
      </ThemeProvider>
    </LoadingProvider>
  );
};

export default AppProviders;
